"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optional = optional;
const incrementPendingClassMetadataCount_1 = require("../actions/incrementPendingClassMetadataCount");
const updateMetadataOptional_1 = require("../actions/updateMetadataOptional");
const buildMaybeClassElementMetadataFromMaybeClassElementMetadata_1 = require("../calculations/buildMaybeClassElementMetadataFromMaybeClassElementMetadata");
const injectBase_1 = require("./injectBase");
function optional() {
    const updateMetadata = (0, buildMaybeClassElementMetadataFromMaybeClassElementMetadata_1.buildMaybeClassElementMetadataFromMaybeClassElementMetadata)(updateMetadataOptional_1.updateMetadataOptional);
    return (0, injectBase_1.injectBase)(updateMetadata, incrementPendingClassMetadataCount_1.incrementPendingClassMetadataCount);
}
//# sourceMappingURL=optional.js.map